import { Timestamp } from "@bufbuild/protobuf";

import { StringValue } from "@safetyculture/s12-apis-connect-web/google/protobuf/wrappers_pb";
import { AttributeValue } from "@safetyculture/s12-apis-connect-web/s12/users/userattribute/v1/attribute_pb";

export const getRawDateAttributeValues = (
  attributeValues: AttributeValue[]
) => {
  return attributeValues.map((attributeValue) => {
    return (attributeValue.value.value as Timestamp).toDate();
  });
};

export const getRawStringAttributeValues = (
  attributeValues: AttributeValue[]
) => {
  return attributeValues.map((attributeValue) => {
    return (attributeValue.value.value as StringValue).value;
  });
};
